var getCustomerId = function () {
  return window.shopifyCustomerID;
};

window.auctionApi = {
  _baseUrl: "https://productauctions.herokuapp.com/api",
  _publicKey:
    "pk_23b7e98fdbb2076ac57e507cc6572609813242b1523291ceed6727ecb8404982",
  getByAuctionIds: function (auction_ids, customer_id) {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let endUrl = "";
    if (customer_id) {
      endUrl = `auctions?platform_customer_id=${customer_id}&auction_ids=${auction_ids}`;
    } else {
      endUrl = `auctions?auction_ids=${auction_ids}`;
    }
    return fetch(`${this._baseUrl}/${endUrl}`, requestOptions);
  },
  getAll: function () {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${this._baseUrl}/auctions`, requestOptions);
  },
  getByID: function (id) {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${this._baseUrl}/auctions/${id}`, requestOptions);
  },
  getBids: function (id) {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${this._baseUrl}/auctions/${id}/bids`, requestOptions);
  },
  placeBid: function (amount, customerId, firstName, lastName, email, id) {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);

    var formdata = new FormData();
    formdata.append("max_bid[amount]", amount);
    formdata.append("max_bid[platform_customer_id]", customerId);
    formdata.append("customer[first_name]", firstName);
    formdata.append("customer[last_name]", lastName);
    formdata.append("customer[email]", email);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/auctions/${id}/max_bids`,
      requestOptions
    );
  },
  getMyAuctions: function (customerId) {
    var myHeaders = new Headers();
    myHeaders.append("X-Public-Key", this._publicKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${this._baseUrl}/customers/${customerId}/auction_history`, requestOptions);
  },
};

window.customerApi = {
  _secretKey: "9FLbhiBkfv9vHYAtpdio0vAwirfRc1fVBfq3zUNg",
  _baseUrl: "https://emedals.saro.space/api/v1",

  getShopifyID: function () {
    return window.shopifyCustomerID;
  },
  verify: function (customerID, media = null, notes = null) {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var formdata = new FormData();
    formdata.append("_method", "PUT");
    formdata.append("customer_id", customerID);
    if (media !== null && media instanceof File) {
      formdata.append("media", media);
    }
    if (notes !== null && notes !== "") {
      formdata.append("notes", notes);
    }
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(`${this._baseUrl}/customers/verification`, requestOptions);
  },
  getArchiveOrders: function(customerID) {
    console.log("getArchiveOrders -> ",customerID);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(`${this._baseUrl}/customers/${customerID}/orders/archive`, requestOptions);
  },
  getCategoryDetails: function (collectionID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(`${this._baseUrl}/category/${collectionID}`, requestOptions);
  },
  getSellToEmedals: function (customerID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/sell-to-us`,
      requestOptions
    );
  },
  getVerification: function (customerID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/verification`,
      requestOptions
    );
  },
  getWantList: function (customerID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wantlists`,
      requestOptions
    );
  },
  addToWantList: function (customerID, collectionId) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wantlists/${collectionId}`,
      requestOptions
    );
  },
  removeFromWantlist: function (customerID, collectionId) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wantlists/${collectionId}`,
      requestOptions
    );
  },
  getWishList: function (customerID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append(
      "X-Secret-Key",
      "9FLbhiBkfv9vHYAtpdio0vAwirfRc1fVBfq3zUNg"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wishlists`,
      requestOptions
    );
  },

  addToWishList: function (customerID, productID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wishlists/product/${productID}`,
      requestOptions
    );
  },
  
  removeFromWishList: function (customerID, productID) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("X-Secret-Key", this._secretKey);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${this._baseUrl}/customers/${customerID}/wishlists/product/${productID}`,
      requestOptions
    );
  },
};

window.globalApi = {
  isCountryRestricted: async function () {
    const restricted_countries = ['CA','AT'];
    const userCountryCookie = window.utils.getCookie('userCountry');
    const lastApiRequestTimestampCookie = window.utils.getCookie('lastApiRequestTimestamp');
    const currentTime = Date.now();
    const expireCookieInDays = 7;

    console.log('COOKIE: Country ->', userCountryCookie,' -- COOKIE: Expire in ->', lastApiRequestTimestampCookie);

    // Check if user's country is stored and if the last API request was made over a week ago
    if (!userCountryCookie || userCountryCookie.trim() === '' || typeof userCountryCookie === 'undefined' || (currentTime - lastApiRequestTimestampCookie) >= expireCookieInDays * 24 * 60 * 60 * 1000) {
      try {
        // Fetch user's country from GEOLOCATION App.
        const response = await fetch('https://api.ipstack.com/check?access_key=c097661ed2a1d95fcb82185ec294bc20');
        const data = await response.json();
        const fetchUserCountry = data ? data.country_code : '' ;

        console.log(fetchUserCountry);
        if (fetchUserCountry === '') return false;

        window.utils.setCookie('userCountry', fetchUserCountry, expireCookieInDays);
        window.utils.setCookie('lastApiRequestTimestamp', currentTime.toString(), expireCookieInDays);

        // Check if user's country is restricted or not
        if (restricted_countries.includes(fetchUserCountry)) {
          return true;
        }
      } catch (error) {
        console.error('Error fetching user country:', error);
        return false;
      }
    }

    // Check if user's country is restricted or not
    if (restricted_countries.includes(userCountryCookie)) {
      return true;
    }
    return false;
  },
  loadTimeZoneData: async function () {
    try {
      const response = await fetch(`https:${window.timeZoneUrl}`);
      const data = await response.json();
      return data;
    } catch (error) {
      return null;
    }
  },

  getTimeZoneAbbreviation: async function() {
    const timeZoneData = await this.loadTimeZoneData();
    if (!timeZoneData) {
      // Handle error loading data
      return null;
    }
  
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const matchedTimeZone = timeZoneData.find(timeZone => timeZone.utc.includes(userTimeZone));
  
    if (matchedTimeZone) {
      return matchedTimeZone.abbr;
    } else {
      return null;
    }
  
  },
  GTRProductNotification: async function(productHandle) {
    try {
      const restricted = await window.globalApi.isCountryRestricted();
      
      if (restricted) {
        // Fetch the product details
        const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
        const product = await response.json();
        
        // Check if the product has GTR tag
        const hasGTRTag = product.tags.some(tag => tag.toLowerCase().includes("gtr"));

        console.log('GTR Tag:', hasGTRTag, product);
        
        if (hasGTRTag) {
          // Check if user is logged in
          if (window.shopifyCustomerID !== '' && window.shopifyCustomerID !== undefined) {
            // Check if user has bypass=true
            const bypass = localStorage.getItem('bypass') === 'true';
            console.log(bypass, localStorage.getItem('bypass'), "< bypass data");
            return bypass;
          }
          return false; // User is not logged in, hide notification
        }
        
        return true; // Product is not tagged with GTR, show notification
      }
      
      return true; // User is not in restricted area, show notification
    } catch (error) {
      console.error('Error in GTR notification:', error);
      return false; // In case of any error, hide notification
    }
  }
};


var get_is_verified = async () => {
  const customer_id = getCustomerId();
  const notVerifiedDetails = document.querySelector(".customer-not-verified-details");
  const verifiedDetails = document.querySelector(".customer-verified-details");
  const pendingDetails = document.querySelector(".customer-pending-details");

  if (customer_id) {
    console.log('hello');
      try {
        const fetch_is_verified = await window.customerApi.getVerification(customer_id);
        const response = await fetch_is_verified.json();
        window.customerVerificationData = response.data;
        const is_verified = response.data ? response.data.is_verified : false;
        const has_submitted_form = response.data ? response.data.has_submitted_form : false;
        const canBypass = response.data ? response.data.can_bypass_blocks : false;

        const localStorageBypassValue = localStorage.getItem('bypass');
        if (localStorageBypassValue === undefined) {
          localStorage.setItem('bypass', canBypass);
        } else {
          localStorage.setItem('bypass', canBypass);
        }
        console.log('keep it up ->', localStorageBypassValue, canBypass);
  
        if (is_verified) {
            // verified
            hideElement(notVerifiedDetails);
            hideElement(pendingDetails);
            showElement(verifiedDetails);
        } else if (!is_verified && has_submitted_form) {
            // pending
            hideElement(notVerifiedDetails);
            hideElement(verifiedDetails);
            showElement(pendingDetails);
        } else {
            // not verified, so upload info
            showElement(notVerifiedDetails);
            hideElement(verifiedDetails);
            hideElement(pendingDetails);
        }
      } catch (error) {
        console.log("is_verified(): ",error)
      }
  } else {
      showElement(notVerifiedDetails);
      hideElement(verifiedDetails);
      localStorage.setItem('bypass', 'false'); // default value
  }
};

get_is_verified();


function containsGTRCategorySentences(sentence) {
  // List of keywords
  const keywords = [
  'Iron Cross 1939',
  'Third Reich Medal Bars',
  'Third Reich Army Awards',
  'Third Reich Army Badges',
  'Third Reich Kriegsmarine Awards & Badges',
  'Third Reich Luftwaffe Awards & Badges',
  'Third Reich National Awards',
  'Third Reich Civil Medals & Awards',
  'NSDAP Awards & Insignia',
  'SA Awards & Insignia',
  'SS Awards & Insignia',
  'Third Reich Stickpins & Ribbon Bars',
  'Third Reich Insignia',
  'Third Reich Armbands',
  'Third Reich Cufftitles',
  'Third Reich Daggers & Swords',
  'Third Reich Uniforms',
  'Third Reich Headgear',
  'Third Reich Belts & Buckles',
  'Third Reich Field Gear',
  'Third Reich Documents & Photos',
  'Third Reich Flags & Militaria',
  'Olympic Games Memorabilia',
  'Third Reich Mixed Awards Lots',
  'Third Reich Mixed Insignia Lots'
];

  /**
   * The expression keywords.join('|') will produce the string:
   * "Luftwaffe|NSDAP|Heer"
   * this means "match Luftwaffe OR NSDAP OR Heer".
   */
  const pattern = new RegExp('\\b(' + keywords.join('|') + ')(?=[,.\\s]|$)', 'i');

  return pattern.test(sentence);
}

function containsKeywords(sentence) {
  // List of keywords
  const keywords = [
      'Luftwaffe', 'NSDAP', 'Heer', 'kriegsmarine', 'wehrmacht', 'Third reich', 
      'HJ', 'SS', 'SA', 'DRL', 'RAD', 'NSKOV', 'DAF', 'DLV', 'Waffen', 'NSKK', 
      'DRK', 'Teno', 'Ordnungspolizei', 'NSFK', 'stahlhelm', 'NSV', 'Luftwaffe.'
  ];

  /**
   * The expression keywords.join('|') will produce the string:
   * "Luftwaffe|NSDAP|Heer"
   * this means "match Luftwaffe OR NSDAP OR Heer".
   */
  const pattern = new RegExp('\\b(' + keywords.join('|') + ')(?=[,.\\s]|$)', 'i');

  return pattern.test(sentence);
}

function hideElement(element) {
  if (element) {
      element.classList.add("hidden");
  }
}

function showElement(element) {
  if (element) {
      element.classList.remove("hidden");
  }
}
